<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Construction Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.vesConstn }}</td>
          <td class="text-xs-left">{{ props.item.vesConstnDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Construction<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="constnDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">{{ labels.valueFormTitle }}</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <form>
              <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs6 v-if="newConstn">
                      <v-text-field v-model="constnForm.vesConstn" :label="labels.vesConstn" :error-messages="errors.collect('vesConstn')" data-vv-name="vesConstn" :data-vv-as="labels.vesConstn" v-validate="'required|param|max:8'"></v-text-field>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-subheader class="queryLabel">{{labels.vesConstn}}</v-subheader>
                      <div class="subheading">{{constnForm.vesConstn}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field v-model="constnForm.vesConstnDesc" :label="labels.vesConstnDesc" :error-messages="errors.collect('vesConstnDesc')" v-validate="'required|entry|max:80'" data-vv-name="vesConstnDesc" :data-vv-as="labels.vesConstnDesc"></v-text-field>
                    </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Vessel Construction? ({{deleteVesConstn}})
      </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Construction', value: 'vesConstn' },
        { text: 'Construction Description', value: 'vesConstnDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Vessel Construction Details',
        vesConstn: 'Construction*',
        vesConstnDesc: 'Construction Description*'
      },
      constnForm: {
        vesConstn: null,
        vesConstnDesc: null
      },
      filters: {
        vesConstn: null,
        vesConstnDesc: null
      },
      constnDialog: null,
      newConstn: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedVesConstn: undefined,
      deleteVesConstn: ''
    }
  },
  computed: {
    constn() {
      return this.$store.state.vessel.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.constn.getVslConstns
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((vesConstn) => {
              const convertConstn = {
                vesConstn: vesConstn.vesConstn,
                vesConstnDesc: vesConstn.vesConstnDesc
              }
              this.items.push(convertConstn)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      // await this.$store.dispatch('vesselManagementInit')
      this.init()
    },
    async doReview(data) {
      this.constnDialog = true
      this.newConstn = false
      const apiURI = this.constn.getVslConstn
      const expand = {
        vesConstn: data.item.vesConstn
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.constnForm.vesConstn = data.vesConstn.vesConstn
          this.constnForm.vesConstnDesc = data.vesConstn.vesConstnDesc
        }
        this.constnDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newConstn = true
      this.constnDialog = true
    },
    doClose() {
      this.newConstn = false
      this.constnDialog = false
      this.constnForm.vesConstn = null
      this.constnForm.vesConstnDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newConstn) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.constn.createVslConstn
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.constnForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.constn.updateVslConstn
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.constnForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesConstn = data
        this.deleteVesConstn = data.vesConstn + ' - ' + data.vesConstnDesc
      }
    },
    async doRemove() {
      const apiURI = this.constn.deleteVslConstn
      if (apiURI) {
        const expand = this.selectedVesConstn
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
